import { Code, ConnectError, createPromiseClient } from "@connectrpc/connect";
import { createConnectTransport } from "@connectrpc/connect-web";
import { AffiliateAPI } from "proto/affiliate/v1/affiliate_api_connect";
import { AggregateAPI } from "proto/aggregate/v1/aggregate_api_connect";
import { AuthAPI } from "proto/auth/v1/auth_connect";
import { ChatAPI } from "proto/chat/v1/chat_api_connect";
import { DiaryAPI } from "proto/diary/v1/diary_api_connect";
import { NotificationAPI } from "proto/notification/v1/notification_api_connect";
import { RoomAPI } from "proto/room/v1/room_api_connect";
import { SettingAPI } from "proto/setting/v1/setting_api_connect";
import { TemplateAPI } from "proto/template/v1/template_api_connect";
import { TournamentAPI } from "proto/tournament/v1/tournament_api_connect";
import { UserAPI } from "proto/user/v1/user_api_connect";
import { BoardAPI } from "proto/whiteboard/board/v1/board_api_connect";
import { apiPath } from "server-props";

export const transport = createConnectTransport({
  baseUrl: apiPath,
  credentials: "include",
  interceptors: [
    (next) => async (request) => {
      // Add your headers here
      try {
        const resp = await next(request);
        console.log({ resp });
        return resp;
      } catch (error) {
        if (
          error instanceof ConnectError &&
          error.code === Code.Unauthenticated
        ) {
          window.location.reload();
        }
        console.log("transaport error", { error });
        throw error;
      }
    },
  ],
});

export const transportWithoutInterceptors = createConnectTransport({
  baseUrl: apiPath,
  credentials: "include",
});

export const settingAPIClient = createPromiseClient(SettingAPI, transport);
export const userAPIClient = createPromiseClient(UserAPI, transport);
export const authAPIClient = createPromiseClient(
  AuthAPI,
  transportWithoutInterceptors
);
export const authAPIWithSessionClient = createPromiseClient(AuthAPI, transport);

export const roomAPIClient = createPromiseClient(RoomAPI, transport);
export const aggAPIClient = createPromiseClient(AggregateAPI, transport);
export const boardAPIClient = createPromiseClient(BoardAPI, transport);
export const templateAPIClient = createPromiseClient(TemplateAPI, transport);
export const notificationAPIClient = createPromiseClient(
  NotificationAPI,
  transport
);
export const diaryAPIClient = createPromiseClient(DiaryAPI, transport);
export const chatAPIClient = createPromiseClient(ChatAPI, transport);
export const tournamentAPIClient = createPromiseClient(
  TournamentAPI,
  transport
);
export const affiliateAPIClient = createPromiseClient(AffiliateAPI, transport);
